<template>
  <div id="app">
    <main class="page">
      <MainCard />
      <ProjectsCard />
    </main>
  </div>
</template>

<script>
import MainCard from './components/MainCard.vue';
import ProjectsCard from './components/ProjectsCard.vue';

export default {
  name: 'App',
  components: {
    MainCard,
    ProjectsCard
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap');

:root {
  --bg: radial-gradient(circle at 20% 20%, #0c1224, #050914 50%);
  --card: rgba(255, 255, 255, 0.04);
  --card-strong: rgba(255, 255, 255, 0.06);
  --accent: #5de4c7;
  --accent-2: #7ca5ff;
  --text: #e8edf7;
  --muted: #9aa5c3;
  --border: rgba(255, 255, 255, 0.08);
  color: var(--text);
  font-family: 'Manrope', 'Segoe UI', system-ui, -apple-system, sans-serif;
  background: var(--bg);
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: var(--bg);
}

#app {
  min-height: 100vh;
}

.page {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 36px 18px 48px;
  max-width: 1080px;
  margin: 0 auto 24px;
}

@media (min-width: 768px) {
  .page {
    padding: 48px 32px 64px;
    gap: 40px;
  }
}
</style>
